import React, { useEffect, useState } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import BreadCrumb from "../../Components/Products/BreadCrumb/BreadCrumb";
import useHamperStore from "../../Stores/useHamperStore";
import styles from "./SpecificHamper.module.css";
import ImageList from "../../Components/Products/SpecificProduct/ImageList";
import { useSwipeable } from "react-swipeable";
import PerfectWith from "../../Components/Products/SpecificProduct/PerfectWith";
import ProductDetailsSection from "../../Components/Products/SpecificProduct/ProductDetailsSection";
import ProductOverview from "../../Components/Products/SpecificProduct/ProductOverview";
import ImageDots from "../../Components/Products/SpecificProduct/ImageDots";
import MainImage from "../../Components/Products/SpecificProduct/MainImage";
import HamperOverview from "./HamperOverview";
import mStyles from "../../Components/Products/SpecificProduct/SpecificProduct.module.css";
import HamperContents from "../../Components/Occasions/SpecificHamper/HamperContents";
import * as fa from "react-icons/fa";
import useContactStore from "../../Stores/useContactStore";
import Collapse from "../../Components/Shared/Collapsable/Collapse";
import { useNavigate } from "react-router-dom";
import useOccasionStore from "../../Stores/useOccasionStore";


function SpecificHamper() {
  const {
    getHamperByFriendlyName,
    selectedHamper,
    errors,
    buildProductSelectionSummary,
    isHamperReadyToOrder,
  } = useHamperStore();
  const [selectedImageIndex, setSelectedImageIndex] = React.useState(0);
  const { OccasionName, HamperName } = useParams();
  const { contact, getContactDetails } = useContactStore();
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };
  useEffect(() => {
    if (OccasionName && HamperName) {
      const getData = async () => {
        await getHamperByFriendlyName(HamperName);
      };
      getData();
    }
  }, [OccasionName, HamperName]);

  const { selectedOccasion, setSelectedOccasion, occasions, getOccasions } = useOccasionStore();
  const location = useLocation();
  useEffect(() => {
    setSelectedImageIndex(0);
  }, [location]);

  const nextItem = () => {
    setSelectedImageIndex(
      selectedImageIndex === selectedHamper.Images.length - 1
        ? 0
        : selectedImageIndex + 1,
    );
  };

  const previousItem = () => {
    setSelectedImageIndex(
      selectedImageIndex === 0
        ? selectedHamper.Images.length - 1
        : selectedImageIndex - 1,
    );
  };

  const handlers = useSwipeable({
    onSwipedLeft: nextItem,
    onSwipedRight: previousItem,
  });

  const buildOrderSummary = () => {
    const selections = buildProductSelectionSummary();
    let summary = `Hello, I would like to order: ${selectedHamper.Name}\n\n With the following options:\n\n`;

    for (const [productName, options] of Object.entries(selections)) {
      summary += `${productName}:\n`;
      if (options && Array.isArray(options)) {
        options.forEach((option) => {
          summary += `\t${option.optionName}: ${option.value}\n`;
        });
      } else {
        summary += `\tNo selection\n`;
      }
      summary += "\n"; // Extra line between products
    }

    return summary;
  };

  const [openContent, setOpenContent] = useState(false);

  const handleWhatsAppOrder = async () => {
    if (!isHamperReadyToOrder()) {
      alert("Please make selections for all products before ordering.");
      setOpenContent(true);
      return;
    }

    const result = await getContactDetails();

    if (!result) {
      alert("Failed to fetch contact details.");
      return;
    }

    const phoneNumber = result?.PhoneNumber || contact.PhoneNumber;

    const message = buildOrderSummary();
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  const handleEmailOrder = async () => {
    if (!isHamperReadyToOrder()) {
      alert("Please make selections for all products before ordering.");
      setOpenContent(true);

      return;
    }

    const result = await getContactDetails();

    if (!result) {
      alert("Failed to fetch contact details.");
      return;
    }

    const emailAddress = result?.Email || contact.Email;
    const subject = `Order Inquiry: ${selectedHamper.Name}`;
    const body = buildOrderSummary();
    const url = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(url, "_blank");
  };

  const navigate = useNavigate();
  const hamperPerfectWith = {
    PerfectWith:
      selectedHamper?.PerfectWith?.map((item) => item?.Product).filter(
        Boolean,
      ) || [],
  };

    useEffect(() => {
    if (OccasionName) {
      const getData = async () => {
        await getOccasions();
      }
      if (occasions.length === 0) {
        getData();
      }
    }
  }, [OccasionName]);

  useEffect(() => {
    if (OccasionName) {
      const occasion = occasions.find(
        (occ) => occ.FriendlyName === OccasionName
      );
      setSelectedOccasion(occasion);
    }
  }, [OccasionName, occasions, setSelectedOccasion]);

  

  return (
    <>
      <div className={styles.BreadCrumbContainer}>
        <BreadCrumb
          Route="Occasions"
          CategoryName={OccasionName}
          CategoryLink={selectedOccasion ? selectedOccasion.FriendlyName : ''}
          ProductName={selectedHamper != null ? selectedHamper?.Name : ""}
        />
      </div>
      {selectedHamper ? (
      <div className={styles.ProductNameMobile}>
              {selectedHamper.Name}
            </div>
      ) : null}
      
      {selectedHamper ? (
        
        <div className={styles.SpecificHamper}>
          <div className={styles.ProductHeader}>
            

            <ImageList
              images={selectedHamper.Images}
              onImageClick={handleImageClick}
            />
            <div {...handlers} className={styles.SwipeableContainer}>
              <div className={styles.ImageNavigation}>
                <div className={styles.prev} onClick={previousItem}>
                  &#10094;
                </div>
                <div className={styles.next} onClick={nextItem}>
                  &#10095;
                </div>
              </div>
              <div className={styles.MainImageWrapper}>
                <MainImage
                  images={selectedHamper.Images}
                  selectedImageIndex={selectedImageIndex}
                />
              </div>
            </div>
            <div className={styles.ImageDots}>
            <ImageDots
              images={selectedHamper.Images}
              selectedImageIndex={handleImageClick}
            />
            </div>
            <div className={styles.HamperOverviewDescription}>
              <HamperOverview hamper={selectedHamper} />
              
            </div>
          </div>

          <div className={styles.HamperDescription}>
                <Collapse title="Hamper Description">
                  {selectedHamper.Description}
                </Collapse>
              </div>
          <HamperContents openContents={openContent} />
          <div className={styles.DeliveryProductOrderOption}>
            <div className={styles.Delivery}>
              <Collapse title="Delivery & Returns">
                <ul>
                  <li>Free island-wide delivery.</li>
                  <li>Two week turnaround.</li>
                  <li>Contact us for urgent orders.</li>
                  <li>Overseas shipping, price discussed before payment.</li>
                  <li>Collections available during pop-up events.</li>
                  <li>Personalised items are non-refundable, unless faulty.</li>
                </ul>
              </Collapse>
            </div>
            <div className={styles.OrderActions}>
              <button
                className={styles.OrderWhatsApp}
                onClick={handleWhatsAppOrder}
              >
                Order via WhatsApp
                <fa.FaWhatsapp className={styles.WhatsAppIcon} />
              </button>

              <button
                className={styles.OrderViaEmail}
                onClick={handleEmailOrder}
              >
                Order via Email
                <fa.FaEnvelope className={styles.EmailIcon} />
              </button>

              <button
                className={styles.EnquireToOrder}
                onClick={() => navigate("/Customer-Services/Contact")}
              >
                Enquire to Order
                <fa.FaPhone className={styles.PhoneIcon} />
              </button>
            </div>
          </div>
          {selectedHamper.PerfectWith &&
            selectedHamper.PerfectWith.length > 0 && (
              <div className={styles.PerfectWithSection}>
                <PerfectWith product={hamperPerfectWith} />
              </div>
            )}
        </div>
      ) : errors && errors.length > 0 ? (
        <div className={styles.ErrorMessages}>an error occurred</div>
      ) : (
        <p>Loading hamper details...</p>
      )}
    </>
  );
}

export default SpecificHamper;
